<template>
  <div>
    <Header :title="title" />

    <div class="content_podat">
      <div v-if="loading" align="center">
        <div class="spin"><Spinner /></div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../components/headerpodat";
import axios from "axios";
import Spinner from "../blocks/spinner";
export default {
  components: {
    Header,
    Spinner,
  },
  data() {
    return {
      title: "Изменить объявления",
      loading: true,
      foto:[],

    };
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.go(-1);
    }
    else  axios.defaults.headers.common["Authorization"] = "Bearer "+localStorage.getItem("token");
  },
  mounted() {
    try {
      axios({
        method: "post",
        url: "https://avtobaza.tj/api/geteditobv",
        data: {
          token: localStorage.getItem("token"),
          id: this.$route.params.id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$store.commit("addpodatid", res.data.obv.id);
         // this.$store.commit("addpodatopsiya", new Array());
          this.$store.commit("addpodatgorod", res.data.obv.gorod);
          this.$store.commit("addpodatgorod_text", res.data.obv.gorod_text);
          this.$store.commit("addpodattip", res.data.obv.tip);
          this.$store.commit("addpodattip_text", res.data.obv.tip_text);
          this.$store.commit("addpodatkateg", res.data.obv.kateg);
          this.$store.commit("addpodatkateg_text", res.data.obv.kateg_text);
          this.$store.commit("addpodatpodkateg", res.data.obv.podkateg);
          this.$store.commit("addpodatpodkateg_text", res.data.obv.podkateg_text);
          this.$store.commit("addpodatmarka", res.data.obv.marka);
          this.$store.commit("addpodatmarka_text", res.data.obv.marka_text);
          this.$store.commit("addpodatmodel", res.data.obv.model);
          this.$store.commit("addpodatmodel_text", res.data.obv.model_text);
          this.$store.commit("addpodatkuzov", res.data.obv.kuzov);
          this.$store.commit("addpodatkuzov_text", res.data.obv.kuzov_text);
          this.$store.commit("addpodatcolor", res.data.obv.color);
          this.$store.commit("addpodatcolor_text", res.data.obv.color_text);
          this.$store.commit("addpodatgod", res.data.obv.god);
          this.$store.commit("addpodattopliva", res.data.obv.topliva);
          this.$store.commit("addpodattopliva_text", res.data.obv.topliva_text);
          this.$store.commit("addpodatkarobka",  res.data.obv.karobka);
          this.$store.commit("addpodatkarobka_text",  res.data.obv.karobka_text);
          this.$store.commit("addpodatprivod", res.data.obv.privod);
           this.$store.commit("addpodatprivod_text", res.data.obv.privod_text);
          this.$store.commit("addpodatobdvigatel", res.data.obv.obdvigatel);
          this.$store.commit("addpodatsena",  res.data.obv.sena);
          this.$store.commit("addpodatbody",  res.data.obv.body);
          this.$store.commit("addpodatprobeg",  res.data.obv.probeg);
          if (res.data.obv.torg == "0") this.$store.commit("addpodattorg", false);
          else this.$store.commit("addpodattorg", true);
          if (res.data.obv.gosnomer == "0") this.$store.commit("addpodatgosnomer", false);
          else this.$store.commit("addpodatgosnomer", true);
          this.$store.commit("addpodatzagolovok", res.data.obv.title);
          this.$store.commit("addpodatkompleckt", res.data.obv.kompleckt);
          this.$store.commit("addpodatkompleckt_text", res.data.obv.kompleckt_text);
          this.$store.commit("addpodattipshina", res.data.obv.tipshina);
          this.$store.commit("addpodattipdiski", res.data.obv.tipdiski);
          this.$store.commit("addpodatprofil", res.data.obv.profil);
          this.$store.commit("addpodatdiametr", res.data.obv.diametr);
          this.$store.commit("addpodatshirina", res.data.obv.shirina);
          this.$store.commit("addpodatpcd", res.data.obv.pcd);
          this.$store.commit("addpodatsostoyanie", res.data.obv.sostoyanie);
          this.$store.commit("addpodatobmen",res.data.obv.obmen);
          this.$store.commit("addpodatobmentext",res.data.obv.obmen_text);
          if (res.data.obv.chat == "0") this.$store.commit("addpodatchat",false);
          else this.$store.commit("addpodatchat",true);
          if (res.data.obv.whatsapp == "0") this.$store.commit("addpodatwhatsapp",false);
          else this.$store.commit("addpodatwhatsapp",true);
           var list=[];
           var j=1;
           if(res.data.obv.images){
            res.data.obv.images.split('|').map(function(value) {
              const newpost = {
                    id: j,
                    image: value
                  };
                  j++
                  list.push(newpost);
              }); 
                        
            this.$store.commit("addpodatfoto", list);
           }
            

          this.$router.push({ name: "Podat" });
        } else {
          this.$router.push({ name: "cbn" });
        }
      });
    } catch (e) {
      alert("Error");
    }
  },
};
</script>
<style scoped>
.content_podat {
  padding: 90px 5px 65px 10px;
}
</style>